



















































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import {Action, Getter, Mutation} from 'vuex-class';
import {CountryEnum} from '@/models/Enums';
import {ActionTypes, GetterTypes, MutationTypes} from '@/modules/neovehicle/store/types';
import {SegmentModel} from '@/modules/neovehicle/models';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import {VueBase} from 'vue-class-component/dist/vue-class-component';

@Component
export default class extends Vue {
  @Prop({default: 'Busca Rápida', required: false, type: String})
  public label: string;

  @Prop({default: 'mdi-lightbulb-on-outline', required: false, type: String})
  public icon: string;

  @Prop({default: '', required: false, type: String})
  public context: string;

  @Getter(GetterTypes.GET_SEGMENT_BY_MODEL)
  public segmentsModel: SegmentModel[];

  @Getter(GET_COUNTRY_SELECTED)
  public country: CountryEnum;

  @Action(ActionTypes.FETCH_SEGMENT_BY_MODEL)
  public getSegmentsByModel: ({modelName, country}: { modelName: string, country: CountryEnum }) => Promise<boolean>;

  @Mutation(MutationTypes.SET_SEGMENT_BY_MODEL)
  public setSegmentsByModel: (value: SegmentModel[]) => void;

  @Ref('search')
  public refSearch: HTMLElement;

  public button = false;
  public search: string = '';
  public isLoading: boolean = false;

  public get onInput() {
    return debounce(() => {
        if (!this.search) {
          this.setSegmentsByModel([]);
          return;
        }

        this.isLoading = true;
        this.getSegmentsByModel({modelName: this.search, country: this.country})
          .then(() => this.isLoading = false);
    }, 500);
  }

  public onClick() {
    setTimeout(() => {
      this.refSearch.focus();
    }, 200);
  }
}
